import { FC, PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { ErrorCard } from './ErrorCard';

export const PageError: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return <ErrorCard error={error} onClear={resetErrorBoundary} />;
};

export const SectionErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={PageError}>{children}</ErrorBoundary>;
};
